import React, { useEffect, useState, useRef, useContext } from 'react';
import styles from './LocationList.module.css';
import { MdOutlineLocationOn } from 'react-icons/md';
import { FaArrowTurnDown, FaArrowTurnUp } from 'react-icons/fa6';
import { BookingsContext } from '../BookingContext';
import { FaGlobeAmericas } from 'react-icons/fa';
import { MdStar, MdStarBorder } from 'react-icons/md';
import FavoriteIcon from './FavoriteIcon';
import GuestLocationBrowser from './GuestLocationBrowser';
import { ButtonCustom } from '../../../../BootstrapComponents/ButtonCustom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { FaPersonWalkingDashedLineArrowRight } from "react-icons/fa6";
import { IoReturnDownBack } from "react-icons/io5";



const LocationList = ({ locations, locationData, nearbyPublicLocations, setLocationCallBack, selectedLocationPast, isMapView, switchMapView, isLoading, user, userLocations }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [locationsList, setLocationsList] = useState(locations.filter(loc => loc.subLocationType !== "CONDO"));

  const [selectedPastLocation, setSelectedPastLocation] = useState(selectedLocationPast);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const [favLocations, setFavLocations] = useState(user?.favLocation);

  const [activeFilter, setActiveFilter] = useState(user?.isGuest ? 'public' : 'privet');
  const [guestPreviewLocation, setGuestPreviewLocation] = useState(null);
  const [guestLocationBreadcrumb, setGuestLocationBreadcrumb] = useState(null);

  const [disableTimeLineSwitch, setDisableTimeLineSwitch] = useState(false)
  const containerRef = useRef(null);

  const { selectedPublicLocation, setSelectedPublicLocation, isBookingLoading } = useContext(BookingsContext);

  // Load selected location from localStorage
  useEffect(() => {
    const savedLocation = localStorage.getItem('selectedLocation');
    if (savedLocation) {
      setSelectedPastLocation(savedLocation);
    }
    // console.log("saved location: ", savedLocation)
    // console.log("user lcoations: ", userLocations)
    if(!savedLocation && userLocations.length === 0){
      // console.log("inside if: ")
      setDisableTimeLineSwitch(true)
    }else{
      setDisableTimeLineSwitch(false)
    }
  }, [locationData, isMapView]);

  useEffect(() => {
    setLocationsList(locations.filter(loc => loc.subLocationType !== "CONDO"))
    setFavLocations(user?.favLocation);
  }, [user?.favLocation]);

  useEffect(() => {
    setSelectedPastLocation(selectedLocationPast);
  }, [selectedLocationPast]);

  useEffect(() => {
    const selected = locationsList?.find((location) => location._id === selectedPastLocation);
    const selectedFav = favLocations?.find((location) => location._id === selectedPastLocation);


    const isPublicLocationInTheList = locationsList?.find(
      (location) => location._id === selectedPublicLocation?._id
    );

    if (!isPublicLocationInTheList && selectedPublicLocation) {
      selectedPublicLocation.fromMap = true;
      setLocationsList([selectedPublicLocation, ...locationsList])
    }


    favLocations?.forEach((favLocation) => {
      const isFavLocationInTheList = locationsList.find((location) => location._id === favLocation._id);
      if (!isFavLocationInTheList) {
        setLocationsList([favLocation, ...locationsList])
      }
    });

    nearbyPublicLocations?.forEach((nearbyPublicLocation) => {
      const isNearbyPublicLocation = locationsList.find((location) => location._id === nearbyPublicLocation._id);
      if (!isNearbyPublicLocation) {
        nearbyPublicLocation.nearby = true;
        setLocationsList([nearbyPublicLocation, ...locationsList])
      }
    });

    if (selected) {
      if(!isOpen)setActiveFilter(selected.public ? 'public' : 'privet');
      
    }
    else if (selectedFav) {
      if(!isOpen)setActiveFilter('public');
      
    }
    else if (selectedPublicLocation && selectedPublicLocation._id === selectedPastLocation) {
      if(!isOpen)setActiveFilter('public');
    }
  }, [locationsList, selectedPastLocation, selectedPublicLocation, nearbyPublicLocations]);


  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
        setGuestPreviewLocation(null);
        setGuestLocationBreadcrumb(null);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  const handleButtonClick = () => {
    setIsOpen(!isOpen);
    setGuestPreviewLocation(null);
    setGuestLocationBreadcrumb(null);
  };

  const handleTabClick = (filterType) => {
    setActiveFilter(filterType);
  };

  const handleLocationClick = (location) => {
    setSelectedPastLocation(location._id);
    setLocationCallBack(location._id);
    setIsOpen(false);
    if (isMapView) switchMapView();
    localStorage.setItem('selectedLocation', location._id);

    // Guests share one pool account across every login, so tag the saved
    // location with the token it was picked under - if a future session shows
    // up with a different token, BookingContext won't pre-select this location.
    if (user?.isGuest) {
      localStorage.setItem('selectedLocationToken', localStorage.getItem('token'));
    }

    if (location.nearby) {
      localStorage.setItem('nearByLocation', location._id);
    }
    else {
      localStorage.removeItem('nearByLocation');
    }

  };

  const isFavorite = (locationId) => {
    return favLocations?.some((location) => location._id === locationId);
  };

  const isMyLocations = (locationId) => {
    return locations?.some((location) => location._id === locationId);
  };

  return (
    <div className={`${styles['locations-container']}`} ref={containerRef}>
      <button
        onClick={user?.isGuest ? undefined : handleButtonClick}
        className={`${styles['btn-locations']} ${isMapView ? styles['btn-map'] : ''}`}
        style={user?.isGuest ? { cursor: 'default' } : undefined}
      >
        {locationData.length > 0 && ((locationData[0]?.locationType==="PUBLIC" || locationData[0]?.locationType==="SHARED-PRIVATE" || locationData[0]?.locationType==="SHARED-PUBLIC" || isMapView) ? (
          <FaGlobeAmericas className={!isMapView ? styles['public-icon'] : ''} />
        ) : (
          <MdOutlineLocationOn />
        ))}
        <span>
          {isMapView ? 'Map View' : (locationData.length > 0 && locationData[0]?.locationName ? locationData[0]?.locationName : "...")}

          {/* locationData?.length > 0 ? locationData[0]?.locationName : (selectedLocation?.locationName ? selectedLocation?.locationName :  '...') */}
        </span>
        {!user?.isGuest && <FaArrowTurnDown />}
      </button>

      {!user?.isGuest && isOpen && (
        <div
          className={`${styles['locations-container-menu']} ${isLoading ? styles['loading'] : ''}`}
        >
          
          {!user?.isGuest && (
            <div
              // disabled={disableTimeLineSwitch}
              // onClick={switchMapView}
              onClick={(disableTimeLineSwitch && isMapView) ? undefined : switchMapView}
              className={`${styles['location-item']} ${styles['btn-map']} ${isMapView ? (!disableTimeLineSwitch ? '' : styles['disabled']) : ''}`}
            >
              {isMapView ? <span className={styles['btn-back-to-timeline']}>Timeline View</span> : 'Map View'}
            </div>
          )}

          {/* Tabs for filters */}
          <div className={styles['locations-filter']}>
            {/* <button
              type='button'
              onClick={() => handleTabClick('all')}
              className={`${styles['filter-tab']} ${activeFilter === 'all' && styles['active']}`}
            >
              All
            </button> */}
            {!user?.isGuest && (
              <button
                type='button'
                onClick={() => handleTabClick('privet')}
                className={`${styles['filter-tab']} ${activeFilter === 'privet' && styles['active']}`}
              >
                My Locations
              </button>
            )}
            <button
              type='button'
              onClick={() => handleTabClick('public')}
              className={`${styles['filter-tab']} ${activeFilter === 'public' && styles['active']}`}
            >
              {user?.isGuest ? 'Locations' : 'Public'}
            </button>
            {!user?.isGuest && (
              <button
                type='button'
                onClick={() => handleTabClick('favorite')}
                className={`${styles['filter-tab']} ${activeFilter === 'favorite' && styles['active']}`}
              >
                Favorites
              </button>
            )}
          </div>

          {(user?.isGuest && activeFilter === 'public') ? (
            <>
              {guestLocationBreadcrumb}
              <GuestLocationBrowser selectedLocationId={selectedPastLocation} onPreviewLocationChange={setGuestPreviewLocation} onBreadcrumbChange={setGuestLocationBreadcrumb} />
              {guestPreviewLocation && (
                <ButtonCustom
                  variant="primary"
                  text="Continue"
                  onClick={() => handleLocationClick(guestPreviewLocation)}
                  style={{ width: '100%', backgroundColor: '#18365E', borderColor: '#18365E' }}
                />
              )}
            </>
          ) : locationsList && locationsList.filter((apt) => {
            if (activeFilter === 'all') return true;
            if (activeFilter === 'favorite') return isFavorite(apt._id);
            if (activeFilter === 'privet') return isMyLocations(apt._id);
            if (activeFilter === 'public') return apt.locationType !== "PRIVATE";
          }).length === 0 ? (
            <div className={styles['no-locations']}>No locations available</div>
          ) : (

            <>
              <>
                {locationsList
                  ?.filter((apt) => {
                    if (activeFilter === 'all') return true;
                    if (activeFilter === 'favorite') return isFavorite(apt._id);
                    if (activeFilter === 'privet') return isMyLocations(apt._id);
                    if (activeFilter === 'public') return apt.locationType !== "PRIVATE";
                  })
                  .map((apt) => (
                    <div
                      className={`${styles['location-item']} ${selectedPastLocation === apt._id && !isMapView ? styles['selected'] : ''
                        }`}
                      key={'apt-' + apt._id}
                      onClick={() => handleLocationClick(apt)}
                    >
                      <span className={styles['name']}>{apt.locationName}</span>
                      {apt.locationType !== "PRIVATE" && (
                        <span className={styles['public-tag']}>
                          {/* {apt?.nearby ? <FaPersonWalkingDashedLineArrowRight className={styles['from-map']} /> : null} */}
                          {/* {apt?.fromMap ? <FaGlobeAmericas className={styles['from-map']} /> : null} */}
                           Public
                        </span>
                      )}
                      {!user?.isGuest && (
                        <FavoriteIcon isFavorite={isFavorite(apt._id)} locationId={apt._id} resultFavLocations={(resultFavLocations) => {
                          setFavLocations(resultFavLocations);
                        }} />
                      )}

                    </div>
                  ))}
              </>
              {(activeFilter === 'public' && !isMapView) &&
                <div className={styles['more-locations']}>
                  <span className={styles['btn']} onClick={()=>{switchMapView();setIsOpen(false);}}>View more</span>
                </div>
              }
            </>

          )}


          <button onClick={handleButtonClick} className={styles['btn-close']}>
            <span>Close</span>
            <FaArrowTurnUp />
          </button>
        </div>
      )}
    </div>
  );
};

LocationList.propTypes = {
  user: PropTypes.object,
  userLocations: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.auth && state.auth.user ? state.auth.user : null,
  userLocations: state.auth && state.auth.user ? state.auth.user.location : [],
});

export default connect(mapStateToProps)(LocationList);
